module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Anchor-right-up-6748d58b2981ca7740412f61cbef1a2f.svg";